import React from 'react';
import PropTypes from 'prop-types';
import cglLogo from 'assets/images/logo-cgl.svg';
import './company-logos.scss';

const CompanyLogos = ({page, deviceInfo}) => {

	return (
		<div className={'CompanyLogos ' + deviceInfo.orientation + (page ? ' ' + page : '')}>
			<div className="CompanyLogos-logo egmont" />
			<div className="CompanyLogos-logo sko" />
			<div className='CompanyLogos-logo cgl' onClick={() => {window.open('https://cphgamelab.dk/', '_blank', 'noopener,noreferrer');}} >
				<img src={cglLogo} alt="Læringsspil udviklet af Copenhagen Game Lab" />
			</div>
			
		</div>
	);
};

CompanyLogos.propTypes = {
	page: PropTypes.string,
	deviceInfo: PropTypes.object.isRequired,
};

export default CompanyLogos;